import {
    FormControl,
    FormLabel,
    Stack,
    Radio,
    RadioGroup,
    WrapItem,
    Tooltip,
    Box,
    Image
} from "@chakra-ui/react"

import MapBgPrevGoogle from "../../assets/images/mapbg-previews/mbgprev-google.jpg"
import MapBgPrevSatelite from "../../assets/images/mapbg-previews/mbgprev-satelite.jpg"
import MapBgPrevDefault from "../../assets/images/mapbg-previews/mbgprev-default.jpg"
import MapBgPrevFlat from "../../assets/images/mapbg-previews/mbgprev-flat.jpg"
import MapBgPrevTransport from "../../assets/images/mapbg-previews/mbgprev-transport.jpg"
import MapBgPrevTransportVintage from "../../assets/images/mapbg-previews/mbgprev-transportvintage.jpg"

const RadioImageOption = ({ imageSrc, altText, radioOptions }) => (
    <Stack>
        <Image src={imageSrc} alt={altText} />
        {radioOptions.map(({ value, label, isDisabled }) => (
            <Radio value={value} isDisabled={isDisabled}>
                {label}
            </Radio>
        ))}
    </Stack>
)

export default function MapBackgroundSelector({
    permitCustomMapBackground,
    selectedBackground,
    setSelectedBackground
}) {
    return (
        <>
            <FormControl display='flex' alignItems='center'>
                <Stack>
                    <FormLabel htmlFor='map-background-select' mb='0'>
                        Map background:
                    </FormLabel>
                    <RadioGroup onChange={setSelectedBackground} value={selectedBackground}>
                        <WrapItem>
                            <Tooltip
                                label='Available only to paid All-Country Pass subscribers with an ongoing subscription.'
                                closeDelay={500}
                                isDisabled={permitCustomMapBackground}
                            >
                                <Stack>
                                    <Stack direction='row'>
                                        <RadioImageOption
                                            imageSrc={MapBgPrevGoogle}
                                            altText="Default Google Maps map background"
                                            radioOptions={[
                                                { value: 'default', label: 'Default (Google)', isDisabled: false }
                                            ]}
                                        />
                                        <RadioImageOption
                                            imageSrc={MapBgPrevSatelite}
                                            altText="Satelite background"
                                            radioOptions={[
                                                { value: 'satelite', label: 'Satelite', isDisabled: !permitCustomMapBackground }
                                            ]}
                                        />
                                    </Stack>
                                    <Stack direction='row'>
                                        <RadioImageOption
                                            imageSrc={MapBgPrevDefault}
                                            altText="Default map background"
                                            radioOptions={[
                                                { value: 'default-osm', label: 'Standard (OSM)', isDisabled: !permitCustomMapBackground },
                                            ]}
                                        />
                                        <RadioImageOption
                                            imageSrc={MapBgPrevFlat}
                                            altText="Flat map background"
                                            radioOptions={[
                                                { value: 'flat-osm', label: 'Flat (English labels)', isDisabled: !permitCustomMapBackground }
                                            ]}
                                        />
                                    </Stack>
                                    <Stack direction='row'>
                                        <RadioImageOption
                                            imageSrc={MapBgPrevTransport}
                                            altText="Transport map background"
                                            radioOptions={[
                                                { value: 'transport-osm', label: 'Railway' }
                                            ]}
                                        />
                                        <RadioImageOption
                                            imageSrc={MapBgPrevTransportVintage}
                                            altText="Transport vintage map background"
                                            radioOptions={[
                                                { value: 'transport-vintage-osm', label: 'Railway (Vintage)' }
                                            ]}
                                        />
                                    </Stack>
                                </Stack>
                            </Tooltip>
                        </WrapItem>
                    </RadioGroup>
                </Stack>
            </FormControl>
        </>
    )
}